import fetch from 'cross-fetch';
import sha2_256 from 'simple-js-sha2-256';
import { stringify } from 'query-string';
import FormData from 'form-data';
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
} // from https://github.com/jonbern/fetch-retry
// and https://github.com/jonbern/fetch-retry/pull/27


function isPositiveInteger(value) {
  return Number.isInteger(value) && value >= 0;
}

var ArgumentError =
/** @class */
function () {
  function ArgumentError(message) {
    this.name = 'ArgumentError';
    this.message = message;
  }

  return ArgumentError;
}();

var transport = function transport(url, options) {
  var retries = 3;
  var retryDelay = 1000;
  var retryOn = [429, 502, 503, 504];

  if (options && options.retries !== undefined) {
    if (isPositiveInteger(options.retries)) {
      retries = options.retries;
    } else {
      throw new ArgumentError('retries must be a positive integer');
    }
  }

  if (options && options.retryDelay !== undefined) {
    if (isPositiveInteger(options.retryDelay) || typeof options.retryDelay === 'function') {
      retryDelay = options.retryDelay;
    } else {
      throw new ArgumentError('retryDelay must be a positive integer or a function returning a positive integer');
    }
  }

  if (options && options.retryOn) {
    if (Array.isArray(options.retryOn) || typeof options.retryOn === 'function') {
      retryOn = options.retryOn;
    } else {
      throw new ArgumentError('retryOn property expects an array or function');
    }
  }

  return new Promise(function (resolve, reject) {
    function retry(attempt, error, response) {
      var delay = typeof retryDelay === 'function' ? retryDelay(attempt, error, response) : retryDelay;
      setTimeout(function () {
        //eslint-disable-next-line @typescript-eslint/no-use-before-define
        wrappedFetch(++attempt);
      }, delay);
    }

    var wrappedFetch = function wrappedFetch(attempt) {
      fetch(url, options).then(function (response) {
        if (Array.isArray(retryOn) && retryOn.indexOf(response.status) === -1) {
          resolve(response);
          return;
        }

        if (typeof retryOn === 'function') {
          if (retryOn(attempt, null, response)) {
            retry(attempt, null, response);
            return;
          }

          resolve(response);
          return;
        }

        if (attempt < retries) {
          retry(attempt, null, response);
          return;
        }

        resolve(response);
      }).catch(function (error) {
        if (typeof retryOn === 'function') {
          if (retryOn(attempt, error, null)) {
            retry(attempt, error, null);
            return;
          }

          reject(error);
          return;
        }

        if (attempt < retries) {
          retry(attempt, error, null);
          return;
        }

        reject(error);
      });
    };

    wrappedFetch(0);
  });
};

var Role;

(function (Role) {
  Role["ADMIN"] = "admin";
  Role["READ"] = "read";
  Role["WRITE"] = "write";
  Role["UPLOAD"] = "upload";
  Role["SOURCEIMAGE_READ"] = "sourceimages:read";
  Role["SOURCEIMAGE_WRITE"] = "sourceimages:write";
  Role["SOURCEIMAGE_UNLOCK"] = "sourceimages:unlock";
  Role["SOURCEIMAGES_DOWNLOAD_PROTECTED"] = "sourceimages:download:protected";
})(Role || (Role = {}));

var memberships = function memberships(state) {
  var ROLES = {
    READ: Role.READ,
    WRITE: Role.WRITE,
    UPLOAD: Role.UPLOAD,
    ADMIN: Role.ADMIN,
    SOURCEIMAGE_READ: Role.SOURCEIMAGE_READ,
    SOURCEIMAGE_WRITE: Role.SOURCEIMAGE_WRITE,
    SOURCEIMAGE_UNLOCK: Role.SOURCEIMAGE_UNLOCK,
    SOURCEIMAGES_DOWNLOAD_PROTECTED: Role.SOURCEIMAGES_DOWNLOAD_PROTECTED
  };
  var memberships = {
    ROLES: ROLES,

    /**
     * Add a member to an organization.
     *
     * ```js
     * rokka.memberships.create('myorg', '613547f8-e26d-48f6-8a6a-552c18b1a290', [rokka.memberships.ROLES.WRITE], "An optional comment")
     *   .then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @authenticated
     * @param  {string}        organization name
     * @param  {string}        userId       UUID of user to add to the organization
     * @param  {string|array}  roles        user roles (`rokka.memberships.ROLES`)
     * @param  {string}  comment            optional comment
     * @return {Promise}
     */
    create: function create(organization, userId, roles, comment) {
      if (typeof roles === 'string') {
        roles = [roles];
      }

      roles.forEach(function (role) {
        if (Object.keys(ROLES).map(function (key) {
          return ROLES[key];
        }).indexOf(role) === -1) {
          return Promise.reject(new Error("Invalid role \"".concat(role, "\"")));
        }
      });
      var path = "organizations/".concat(organization, "/memberships/").concat(userId);
      return state.request('PUT', path, {
        roles: roles,
        comment: comment
      });
    },

    /**
     * Delete a member in an organization.
     *
     * ```js
     * rokka.memberships.delete('myorg', '613547f8-e26d-48f6-8a6a-552c18b1a290')
     *   .then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @authenticated
     * @param  {string}        organization name
     * @param  {string}        userId       UUID of user to add to the organization
     * @return {Promise}
     */
    delete: function _delete(organization, userId) {
      var path = "organizations/".concat(organization, "/memberships/").concat(userId);
      return state.request('DELETE', path);
    },

    /**
     * Create a user and membership associated to this organization.
     *
     * ```js
     * rokka.memberships.createWithNewUser('myorg', [rokka.memberships.ROLES.READ], "New user for something")
     *   .then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @authenticated
     * @param  {string}  organization name
     * @param  {array}   roles        user roles (`rokka.memberships.ROLES`)
     * @param  {string}  comment      optional comment
     * @return {Promise}
     */
    createWithNewUser: function createWithNewUser(organization, roles, comment) {
      roles.forEach(function (role) {
        if (Object.keys(ROLES).map(function (key) {
          return ROLES[key];
        }).indexOf(role) === -1) {
          return Promise.reject(new Error("Invalid role \"".concat(role, "\"")));
        }
      });
      var path = "organizations/".concat(organization, "/memberships");
      return state.request('POST', path, {
        roles: roles,
        comment: comment
      });
    },

    /**
     * Lists members in an organization.
     *
     * ```js
     * rokka.memberships.list('myorg')
     *   .then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @authenticated
     * @param  {string}        organization name
     * @return {Promise}
     */
    list: function list(organization) {
      var path = "organizations/".concat(organization, "/memberships");
      return state.request('GET', path);
    },

    /**
     * Get info of a member in an organization.
     *
     * ```js
     * rokka.memberships.get('myorg',userId)
     *   .then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @authenticated
     * @param  {string}        organization name
     * @param  {string}        userId
     * @return {Promise}
     */
    get: function get(organization, userId) {
      var path = "organizations/".concat(organization, "/memberships/").concat(userId);
      return state.request('GET', path);
    }
  };
  return {
    memberships: memberships
  };
};

var ResizeMode;

(function (ResizeMode) {
  ResizeMode["Box"] = "box";
  ResizeMode["Fill"] = "fill";
  ResizeMode["Absolute"] = "absolute";
})(ResizeMode || (ResizeMode = {}));

var CompositionMode;

(function (CompositionMode) {
  CompositionMode["Foreground"] = "foreground";
  CompositionMode["Background"] = "background";
})(CompositionMode || (CompositionMode = {}));

var operations = function operations(state) {
  var operations = {
    resize: function resize(width, height, options) {
      if (options === void 0) {
        options = {};
      }

      options.width = width;
      options.height = height;
      return {
        name: 'resize',
        options: options
      };
    },
    autorotate: function autorotate(options) {
      if (options === void 0) {
        options = {};
      }

      return {
        name: 'autorotate',
        options: options
      };
    },
    rotate: function rotate(angle, options) {
      if (options === void 0) {
        options = {};
      }

      options.angle = angle;
      return {
        name: 'rotate',
        options: options
      };
    },
    dropshadow: function dropshadow(options) {
      if (options === void 0) {
        options = {};
      }

      return {
        name: 'dropshadow',
        options: options
      };
    },
    trim: function trim(options) {
      if (options === void 0) {
        options = {};
      }

      return {
        name: 'trim',
        options: options
      };
    },
    crop: function crop(width, height, options) {
      if (options === void 0) {
        options = {};
      }

      options.width = width;
      options.height = height;
      return {
        name: 'crop',
        options: options
      };
    },
    noop: function noop() {
      return {
        name: 'noop'
      };
    },
    composition: function composition(width, height, mode, options) {
      if (options === void 0) {
        options = {};
      }

      options.width = width;
      options.height = height;
      options.mode = mode;
      return {
        name: 'composition',
        options: options
      };
    },
    blur: function blur(sigma, radius) {
      var options = {
        sigma: sigma,
        radius: radius
      };
      return {
        name: 'blur',
        options: options
      };
    },

    /**
     * Get a list of available stack operations.
     *
     * ```js
     * rokka.operations.list()
     *   .then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @return {Promise}
     */
    list: function list() {
      return state.request('GET', 'operations', null, null, {
        noAuthHeaders: true
      });
    }
  };
  return {
    operations: operations
  };
};

var organizations = function organizations(state) {
  var organizations = {
    OPTION_PROTECT_DYNAMIC_STACK: 'protect_dynamic_stack',

    /**
     * Get a list of organizations.
     *
     * ```js
     * rokka.organizations.get('myorg')
     *   .then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @authenticated
     * @param  {string}  name organization
     * @return {Promise}
     */
    get: function get(name) {
      return state.request('GET', "organizations/".concat(name));
    },

    /**
     * Create an organization.
     *
     * ```js
     * rokka.organizations.create('myorg', 'billing@example.org', 'Organization Inc.')
     *   .then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @authenticated
     * @param  {string}  name         organization
     * @param  {string}  billingEmail email used for billing
     * @param  {string}  displayName  pretty name
     * @return {Promise}
     */
    create: function create(name, billingEmail, displayName) {
      return state.request('PUT', "organizations/".concat(name), {
        billing_email: billingEmail,
        display_name: displayName
      });
    },
    setOption: function setOption(organizationName, name, value) {
      return state.request('PUT', "organizations/".concat(organizationName, "/options/").concat(name), value);
    }
  };
  return {
    organizations: organizations
  };
};
/**
 * ### expressions
 *
 * @module expressions
 */


var expressions = function expressions() {
  var expressions = {
    default: function _default(expression, options) {
      return {
        expression: expression,
        overrides: {
          options: options
        }
      };
    }
  };
  return {
    expressions: expressions
  };
};

function e(e) {
  this.message = e;
}

e.prototype = new Error(), e.prototype.name = "InvalidCharacterError";

var r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function (r) {
  var t = String(r).replace(/=+$/, "");
  if (t.length % 4 == 1) throw new e("'atob' failed: The string to be decoded is not correctly encoded.");

  for (var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) ? c += String.fromCharCode(255 & n >> (-2 * a & 6)) : 0) {
    o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
  }

  return c;
};

function t(e) {
  var t = e.replace(/-/g, "+").replace(/_/g, "/");

  switch (t.length % 4) {
    case 0:
      break;

    case 2:
      t += "==";
      break;

    case 3:
      t += "=";
      break;

    default:
      throw "Illegal base64url string!";
  }

  try {
    return function (e) {
      return decodeURIComponent(r(e).replace(/(.)/g, function (e, r) {
        var t = r.charCodeAt(0).toString(16).toUpperCase();
        return t.length < 2 && (t = "0" + t), "%" + t;
      }));
    }(t);
  } catch (e) {
    return r(t);
  }
}

function n(e) {
  this.message = e;
}

function o(e, r) {
  if ("string" != typeof e) throw new n("Invalid token specified");
  var o = !0 === (r = r || {}).header ? 0 : 1;

  try {
    return JSON.parse(t(e.split(".")[o]));
  } catch (e) {
    throw new n("Invalid token specified: " + e.message);
  }
}

n.prototype = new Error(), n.prototype.name = "InvalidTokenError";

function stringifyOperations(operations) {
  var stackoperations = Array.isArray(operations) ? operations : [operations];
  return stackoperations.map(function (operation) {
    var name = operation.name;
    var options = Object.keys(operation.options || {}).map(function (k) {
      return "".concat(k, "-").concat(operation.options && operation.options[k] ? operation.options[k] : '__undefined__');
    }).join('-');

    if (!options) {
      return name;
    }

    return "".concat(name, "-").concat(options);
  }).join('--');
}

function isStream(stream) {
  return stream !== null && typeof stream === 'object' && typeof stream.pipe === 'function';
}

function _isTokenExpiring(exp, apiTokenGetCallback, withinNextSeconds) {
  if (withinNextSeconds === void 0) {
    withinNextSeconds = 3600;
  }

  var validFor = _tokenValidFor(exp, apiTokenGetCallback);

  return withinNextSeconds > validFor;
}

function _tokenValidFor(exp, apiTokenGetCallback) {
  if (!exp) {
    var payload = _getTokenPayload(apiTokenGetCallback);

    exp = payload === null || payload === void 0 ? void 0 : payload.exp;
  }

  if (!exp) {
    return -1;
  }

  var now = new Date().getTime() / 1000;
  return exp - now;
}

function _getTokenPayload(apiTokenGetCallback) {
  if (!apiTokenGetCallback) {
    return null;
  }

  var token;

  if (typeof apiTokenGetCallback === 'string') {
    token = apiTokenGetCallback;
  } else {
    token = apiTokenGetCallback();
  }

  if (!token) {
    return null;
  }

  try {
    return o(token);
  } catch (_a) {
    return null;
  }
} // currently only gets stack variables


var getStackComponents = function getStackComponents(stack) {
  // split by slashes
  // TODO: if we parse operations and options, only the stuff before the first / is a dynamic operation
  // otherwise it's just new options for that operation
  // but we don't parse operations yet, here.
  var slashSplits = stack.split('/');
  var variables = {};

  for (var i = 0; i < slashSplits.length; i++) {
    var slashSplit = slashSplits[i]; // then by --, both are valid seperators here

    var dashSplits = slashSplit.split('--');

    for (var j = 0; j < dashSplits.length; j++) {
      var dashSplit = dashSplits[j]; // and get the object for the variables (or other "parts", later)

      var _a = dashSplit.split('-'),
          operationName = _a[0],
          options = _a.slice(1);

      if (operationName === 'v' || operationName === 'variables') {
        var name_1 = ''; // we have a match, set it to empty

        dashSplits[j] = '';

        for (var k = 0; k < options.length; k++) {
          if (k % 2 === 0) {
            name_1 = options[k];
          } else {
            variables[name_1] = options[k];
          }
        }
      }
    } // put them back together


    slashSplits[i] = dashSplits.filter(function (dashSplit) {
      return dashSplit !== '';
    }).join('--');
  }

  var stackString = slashSplits.filter(function (slashSplit) {
    return slashSplit !== '';
  }).join('/');
  return {
    variables: variables,
    stackString: stackString
  };
};

var getUrlComponents = function getUrlComponents(urlObject) {
  var _a;

  var stackPattern = '(?<stack>.*([^-]|--)|-*)';
  var hashPattern = '(?<hash>[0-9a-f]{6,40})';
  var filenamePattern = '(?<filename>[^\\/^.]+)';
  var formatPattern = '(?<format>.{2,4})';
  var pathPattern = '(?<hash>-.+-)';
  var regExes = [new RegExp("/".concat(stackPattern, "/").concat(hashPattern, "/").concat(filenamePattern, ".").concat(formatPattern)), new RegExp("/".concat(stackPattern, "/").concat(hashPattern, ".").concat(formatPattern)), new RegExp("/".concat(stackPattern, "/").concat(pathPattern, "/").concat(filenamePattern, ".").concat(formatPattern)), new RegExp("/".concat(stackPattern, "/").concat(pathPattern, ".").concat(formatPattern))];
  var path = urlObject.pathname;
  var matches = null;

  for (var i = 0; i < regExes.length; i++) {
    matches = path.match(regExes[i]);

    if (matches) {
      break;
    }
  }

  if (matches !== null && ((_a = matches.groups) === null || _a === void 0 ? void 0 : _a['stack'])) {
    return {
      stack: matches.groups['stack'],
      hash: matches.groups['hash'],
      format: matches.groups['format'],
      filename: matches.groups['filename']
    };
  }

  return false;
};

var stringifyBool = function stringifyBool(value) {
  if (value === false) {
    return 'false';
  }

  if (value === true) {
    return 'true';
  }

  return value;
};
/**
 * ### Render
 *
 * @module render
 */


var render = function render(state) {
  var render = {
    /**
     * Get URL for rendering an image.
     *
     * ```js
     * rokka.render.getUrl('myorg', 'c421f4e8cefe0fd3aab22832f51e85bacda0a47a', 'png', 'mystack')
     * ```
     *
     * @param  {string}                     organization name
     * @param  {string}                      hash        image hash
     * @param  {string}                      format      image format: `jpg`, `png` or `gif`
     * @param  {string|array}                [mixed]     optional stack name or an array of stack operation objects
     * @param  {{filename:string|undefined}} options     Optional. filename: Adds the filename to the URL
     * @return {string}
     */
    getUrl: function getUrl(organization, hash, format, mixed, options) {
      var host = state.renderHost.replace('{organization}', organization);
      var mixedParam = Array.isArray(mixed) ? "dynamic/".concat(stringifyOperations(mixed)) // array of operations
      : mixed; // stack name

      var stack = mixedParam || 'dynamic/noop';

      if (options === null || options === void 0 ? void 0 : options.filename) {
        hash = "".concat(hash, "/").concat(options.filename);
      }

      return "".concat(host, "/").concat(stack, "/").concat(hash, ".").concat(format);
    },

    /**
     * Get image hashes and some other info belonging to a album (from metadata: user:array:albums)
     * ```js
     * rokka.render.imagesByAlbum('myorg', 'Albumname', { favorites })
     * ```
     *
     * @param {string}               organization  name
     * @param {string }              album         albumname
     * @param {{favorites:boolean}}  options       Optional options
     */
    imagesByAlbum: function imagesByAlbum(organization, album, options) {
      var host = state.renderHost.replace('{organization}', organization);
      var filename = 'all';

      if (options === null || options === void 0 ? void 0 : options.favorites) {
        filename = 'favorites';
      }

      return state.request('GET', "_albums/".concat(album, "/").concat(filename, ".json"), null, undefined, {
        host: host,
        noAuthHeaders: true,
        noTokenRefresh: true
      });
    },

    /**
     * Signs a Rokka URL with an option valid until date.
     *
     * It also rounds up the date to the next 5 minutes (300 seconds) to
     * improve CDN caching, can be changed
     *
     * @param {string}  url The Url to be signed
     * @param {string}  signKey The organinzation's sign key
     * @param {SignUrlOptions} [{until:Date = null, roundDateUpTo:number = 300}] optional options.
     *                  until: Valid until,
     *                  roundDateUpTo: For improved caching, the date can be rounded up by so many seconds (default: 300)
     * @return {string}
     */
    signUrl: function signUrl(url, signKey, _a) {
      var _b = _a === void 0 ? {} : _a,
          _c = _b.until,
          until = _c === void 0 ? null : _c,
          _d = _b.roundDateUpTo,
          roundDateUpTo = _d === void 0 ? 300 : _d;

      var options = null;

      if (until) {
        var until2 = until;

        if (roundDateUpTo > 1) {
          until2 = new Date();
          until2.setTime(Math.ceil(until.getTime() / (roundDateUpTo * 1000)) * (roundDateUpTo * 1000));
        }

        options = {
          until: until2.toISOString()
        };
      }

      return render.signUrlWithOptions(url, signKey, options);
    },

    /**
     * Signs a rokka URL with a sign key and optional signature options.
     *
     */
    signUrlWithOptions: function signUrlWithOptions(url, signKey, options) {
      var urlObject = new URL(url); // generate sigopts

      if (options) {
        urlObject.searchParams.set('sigopts', JSON.stringify(options));
      } else {
        urlObject.searchParams.delete('sigopts');
      } // remove sig


      urlObject.searchParams.delete('sig');
      var urlPath = urlObject.pathname + urlObject.search;
      var sigString = urlPath + ':' + signKey;
      var hash = sha2_256(sigString); // append new sig

      urlObject.searchParams.append('sig', hash.substring(0, 16));
      return urlObject.toString();
    },

    /**
     * Adds stack variables to a rokka URL in a safe way
     *
     * Uses the v query parameter, if a variable shouldn't be in the path
     *
     * @param {string} url                    The url the stack variables are added to
     * @param {object} variables              The variables to add
     * @param {bool}   [removeSafeUrlFromQuery=false] If true, removes some safe characters from the query
     * @return {string}
     */
    addStackVariables: function addStackVariables(url, variables, removeSafeUrlFromQuery) {
      if (removeSafeUrlFromQuery === void 0) {
        removeSafeUrlFromQuery = false;
      }

      var urlObject = new URL(url);
      var urlComponents = getUrlComponents(urlObject);

      if (!urlComponents) {
        return url;
      }

      var stackComponents = getStackComponents(urlComponents.stack);
      var variablesFromPath = stackComponents.variables;
      var vQuery = urlObject.searchParams.get('v');
      var vQueryParsed = vQuery !== null ? JSON.parse(vQuery) : {};
      var returnVariables = Object.assign(variablesFromPath, vQueryParsed, variables); // put variales into url string or v parameter, depending on characters in it

      if (Object.keys(returnVariables).length > 0) {
        var jsonVariables = {};
        var urlVariables = '';

        for (var name_2 in returnVariables) {
          var value = returnVariables[name_2];

          if (value || value === false) {
            var valueAsString = value.toString(); // if there's a special var in the value, put it into the v query parameter

            if (valueAsString.match(/[$/\\\-#%&?;]/)) {
              jsonVariables[name_2] = stringifyBool(value);
            } else {
              urlVariables += '-' + name_2 + '-' + stringifyBool(value);
            }
          }
        }

        if (urlVariables !== '') {
          stackComponents.stackString += '/v' + urlVariables;
        }

        if (Object.keys(jsonVariables).length > 0) {
          urlObject.searchParams.set('v', JSON.stringify(jsonVariables));
        } else {
          urlObject.searchParams.delete('v');
        }
      }

      urlObject.pathname = stackComponents.stackString + '/' + urlComponents.hash + (urlComponents.filename ? '/' + urlComponents.filename : '') + '.' + urlComponents.format; // remove url safe characters on demand for "nicer" urls in demos and such

      if (removeSafeUrlFromQuery) {
        var query = urlObject.search;
        urlObject.search = '';
        return urlObject.toString() + query.replace(/%22/g, '"').replace(/%20/g, ' ').replace(/%2C/g, ',').replace(/%7B/g, '{').replace(/%7D/g, '}').replace(/%3A/g, ':');
      }

      return urlObject.toString();
    },

    /**
     * Get rokka components from an URL object.
     *
     * Returns false, if it could not parse it as rokka URL.
     *
     * @param {URL} urlObject
     * @return  {UrlComponents|false}
     */
    getUrlComponents: getUrlComponents
  };
  return {
    render: render
  };
};
/**
 * ### Source Images
 *
 * @module sourceimages.meta
 */


var SourceImagesMeta = function SourceImagesMeta(state) {
  return {
    /**
     * ### User metadata
     *
     * See [the user metadata documentation](https://rokka.io/documentation/references/user-metadata.html)
     * for more information.
     */

    /**
     * Add user metadata to a source image.
     *
     * See [the user metadata documentation](https://rokka.io/documentation/references/user-metadata.html)
     * for an explanation.
     *
     * ```js
     * rokka.sourceimages.meta.add('myorg', 'c421f4e8cefe0fd3aab22832f51e85bacda0a47a', {
     *   somefield: 'somevalue',
     *   'int:some_number': 0,
     *   'delete_this': null
     * }).then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @authenticated
     * @param {string} organization name
     * @param {string} hash         image hash
     * @param {object} data         metadata to add to the image
     * @return {Promise}
     */
    add: function add(organization, hash, data) {
      return state.request('PATCH', "sourceimages/".concat(organization, "/").concat(hash, "/meta/user"), data);
    },

    /**
     * Replace user metadata of a source image with the passed data.
     *
     * See [the user metadata documentation](https://rokka.io/documentation/references/user-metadata.html)
     * for an explanation.
     *
     * ```js
     * rokka.sourceimages.meta.replace('myorg', 'c421f4e8cefe0fd3aab22832f51e85bacda0a47a', {
     *   somefield: 'somevalue',
     *   'int:some_number': 0
     * }).then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @authenticated
     * @param {string} organization name
     * @param {string} hash         image hash
     * @param {object} data         new metadata
     * @return {Promise}
     */
    replace: function replace(organization, hash, data) {
      return state.request('PUT', "sourceimages/".concat(organization, "/").concat(hash, "/meta/user"), data);
    },

    /**
     * Replace user metadata of a source image with the passed data.
     *
     * See [the user metadata documentation](https://rokka.io/documentation/references/user-metadata.html)
     * for an explanation.
     *
     * ```js
     * rokka.sourceimages.meta.delete('myorg', 'c421f4e8cefe0fd3aab22832f51e85bacda0a47a')
     *   .then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * If the third parameter (field) is specified, it will just delete this field.
     *
     * @authenticated
     * @param {string} organization name
     * @param {string} hash         image hash
     * @param {string} [field=null] optional field to delete
     * @return {Promise}
     */
    delete: function _delete(organization, hash, field) {
      if (field === void 0) {
        field = null;
      }

      var fieldpath = field ? "/".concat(field) : '';
      return state.request('DELETE', "sourceimages/".concat(organization, "/").concat(hash, "/meta/user").concat(fieldpath));
    }
  };
};

function stream2buffer(stream) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2
      /*return*/
      , new Promise(function (resolve, reject) {
        var _buf = Array();

        stream.on('data', function (chunk) {
          return _buf.push(chunk);
        });
        stream.on('end', function () {
          return resolve(Buffer.concat(_buf));
        });
        stream.on('error', function (err) {
          return reject("error converting stream - ".concat(err));
        });
      })];
    });
  });
}
/**
 * ### Source Images
 *
 * @module sourceimages
 */


var sourceimages = function sourceimages(state) {
  var sourceimages = {
    /**
     * Get a list of source images.
     *
     * By default, listing sourceimages sorts them by created date descending.
     *
     * ```js
     * rokka.sourceimages.list('myorg')
     *   .then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * Searching for images can be achieved using the `search` parameter.
     * Supported are predefined fields like `height`, `name` etc. but also user metadata.
     * If you search for user metadata, the field name has to be prefixed with `user:TYPE`.
     * All fields are combined with an AND. OR/NOT is not possible.
     *
     * Example:
     *
     * ```js
     * const search = {
     *   'user:int:id': '42',
     *   'height': '64'
     * }
     * rokka.sourceimages.list('myorg', { search: search })
     *   .then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * The search also supports range and wildcard queries.
     * Check out [the rokka documentation](https://rokka.io/documentation/references/searching-images.html) for more.
     *
     * Sorting works with user metadata as well and can be passed as either an array or as a
     * comma separated string.
     *
     * @authenticated
     * @param  {string} organization  name
     * @param  {Object} params Query string params (limit, offset, sort and search)
     * @return {Promise}
     */
    list: function list(organization, _a) {
      var _b = _a === void 0 ? {} : _a,
          _c = _b.limit,
          limit = _c === void 0 ? null : _c,
          _d = _b.offset,
          offset = _d === void 0 ? null : _d,
          _e = _b.sort,
          sort = _e === void 0 ? null : _e,
          _f = _b.search,
          search = _f === void 0 ? null : _f,
          _g = _b.facets,
          facets = _g === void 0 ? null : _g,
          _h = _b.deleted,
          deleted = _h === void 0 ? null : _h;

      var queryParams = {};

      if (limit !== null) {
        queryParams.limit = limit;
      }

      if (offset !== null) {
        queryParams.offset = offset;
      }

      if (facets !== null) {
        queryParams.facets = facets;
      }

      if (deleted !== null) {
        queryParams.deleted = deleted;
      }

      if (sort !== null) {
        if (Array.isArray(sort)) {
          sort = sort.join(',');
        }

        queryParams.sort = sort;
      }

      if (search !== null) {
        queryParams = Object.assign(queryParams, search);
      }

      return state.request('GET', "sourceimages/".concat(organization), null, queryParams);
    },

    /**
     * Get information of a source image by hash.
     *
     * ```js
     * rokka.sourceimages.get('myorg', 'c421f4e8cefe0fd3aab22832f51e85bacda0a47a')
     *   .then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @authenticated
     * @param  {string}  organization name
     * @param  {string}  hash         image hash
     * @param  {Object}  queryParams  like {deleted: true}
     * @return {Promise}
     */
    get: function get(organization, hash, queryParams) {
      if (queryParams === void 0) {
        queryParams = {};
      }

      return state.request('GET', "sourceimages/".concat(organization, "/").concat(hash), null, queryParams);
    },

    /**
     * Get information of a source image by its binary hash.
     *
     * ```js
     * rokka.sourceimages.getWithBinaryHash('myorg', 'b23e17047329b417d3902dc1a5a7e158a3ee822a')
     *   .then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @authenticated
     * @param  {string}  organization name
     * @param  {string}  binaryHash   binary image hash
     * @return {Promise}
     */
    getWithBinaryHash: function getWithBinaryHash(organization, binaryHash) {
      var queryParams = {
        binaryHash: binaryHash
      };
      return state.request('GET', "sourceimages/".concat(organization), null, queryParams);
    },

    /**
     * Download image by hash, returns a Stream
     *
     * ```js
     * rokka.sourceimages.download('myorg', 'c421f4e8cefe0fd3aab22832f51e85bacda0a47a')
     *   .then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @authenticated
     * @param  {string}  organization name
     * @param  {string}  hash         image hash
     * @return {Promise}
     */
    download: function download(organization, hash) {
      return state.request('GET', "sourceimages/".concat(organization, "/").concat(hash, "/download"), undefined, undefined, {
        fallBackToText: true
      });
    },

    /**
     * Download image by hash, returns a Buffer
     *
     * ```js
     * rokka.sourceimages.downloadAsBuffer('myorg', 'c421f4e8cefe0fd3aab22832f51e85bacda0a47a')
     *   .then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @authenticated
     * @param  {string}  organization name
     * @param  {string}  hash         image hash
     * @return {Promise}
     */
    downloadAsBuffer: function downloadAsBuffer(organization, hash) {
      return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , state.request('GET', "sourceimages/".concat(organization, "/").concat(hash, "/download")).then(function (response) {
                return __awaiter(void 0, void 0, void 0, function () {
                  var _a;

                  var _b;

                  return __generator(this, function (_c) {
                    switch (_c.label) {
                      case 0:
                        _a = [_assign({}, response)];
                        _b = {};
                        return [4
                        /*yield*/
                        , stream2buffer(response.body)];

                      case 1:
                        return [2
                        /*return*/
                        , _assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]))];
                    }
                  });
                });
              })];

            case 1:
              return [2
              /*return*/
              , _a.sent()];
          }
        });
      });
    },

    /**
     * Autolabels an image.
     *
     * You need to be a paying customer to be able to use this.
     *
     * ```js
     * rokka.sourceimages.autolabel('myorg', 'c421f4e8cefe0fd3aab22832f51e85bacda0a47a')
     *   .then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @authenticated
     * @param  {string}  organization name
     * @param  {string}  hash         image hash
     * @return {Promise}
     */
    autolabel: function autolabel(organization, hash) {
      return state.request('POST', "sourceimages/".concat(organization, "/").concat(hash, "/autolabel"));
    },

    /**
     * Upload an image.
     *
     * ```js
     * const file = require('fs').createReadStream('picture.png');
     * rokka.sourceimages.create('myorg', 'picture.png', file)
     *   .then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * With directly adding metadata:
     *
     * ```
     * rokka.sourceimages.create('myorg', 'picture.png', file, {'meta_user': {'foo': 'bar'}})
     * ```
     *
     * @authenticated
     * @param  {string} organization    name
     * @param  {string} fileName        file name
     * @param  {*}      binaryData      either a readable stream (in node.js only) or a binary string
     * @param  {Object} [metadata=null] optional, metadata to be added, either user or dynamic
     * @param  {{optimize_source: boolean}} [options={}] Optional: only {optimize_source: true/false} yet, false is default
     * @return {Promise}
     */
    create: function create(organization, fileName, binaryData, metadata, options) {
      if (metadata === void 0) {
        metadata = null;
      }

      if (options === void 0) {
        options = {};
      }

      var config = {
        multipart: true
      };
      return new Promise(function (resolve) {
        // Stream and Buffer are only supported by node.js and not browsers natively
        // We just asume that a browser based solution will provide the binaryData
        // of the image as String. But patches are welcome for stream alternatives
        // in browsers
        if (isStream(binaryData)) {
          var chunks_1 = [];
          binaryData.on('data', function (chunk) {
            return chunks_1.push(chunk);
          });
          binaryData.on('end', function () {
            return resolve(Buffer.concat(chunks_1));
          });
        } else {
          resolve(binaryData);
        }
      }).then(function (data) {
        var formData = _assign({}, options);

        if (metadata !== null) {
          Object.keys(metadata).forEach(function (o) {
            var data = metadata[o];
            formData[o + '[0]'] = typeof data === 'string' ? data : JSON.stringify(data);
          });
        }

        var payload = {
          name: 'filedata',
          formData: formData,
          filename: fileName,
          contents: data
        };
        return state.request('POST', "sourceimages/".concat(organization), payload, null, config);
      });
    },

    /**
     * Upload an image by url.
     *
     * ```js
     * rokka.sourceimages.createByUrl('myorg', 'https://rokka.rokka.io/dynamic/f4d3f334ba90d2b4b00e82953fe0bf93e7ad9912.png')
     *   .then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * With directly adding metadata:
     *
     * ```
     * rokka.sourceimages.createByUrl('myorg',  'https://rokka.rokka.io/dynamic/f4d3f334ba90d2b4b00e82953fe0bf93e7ad9912.png', {'meta_user': {'foo': 'bar'}})
     * ```
     *
     * @authenticated
     * @param  {string} organization     name
     * @param  {string} url              The URL to the remote image
     * @param  {Object} [metadata=null]  optional, metadata to be added, either user or dynamic
     * @param  {{optimize_source: boolean}} [options={}] Optional: only {optimize_source: true/false} yet, false is default
     * @return {Promise}
     */
    createByUrl: function createByUrl(organization, url, metadata, options) {
      if (metadata === void 0) {
        metadata = null;
      }

      if (options === void 0) {
        options = {};
      }

      var config = {
        form: true
      };

      var formData = _assign({
        'url[0]': url
      }, options);

      if (metadata !== null) {
        Object.keys(metadata).forEach(function (o) {
          var data = metadata[o];
          formData[o + '[0]'] = typeof data === 'string' ? data : JSON.stringify(data);
        });
      }

      return state.request('POST', "sourceimages/".concat(organization), formData, null, config);
    },

    /**
     * Delete image by hash.
     *
     * ```js
     * rokka.sourceimages.delete('myorg', 'c421f4e8cefe0fd3aab22832f51e85bacda0a47a')
     *   .then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @authenticated
     * @param  {string}  organization name
     * @param  {string}  hash         image hash
     * @return {Promise}
     */
    delete: function _delete(organization, hash) {
      return state.request('DELETE', "sourceimages/".concat(organization, "/").concat(hash));
    },

    /**
     * Delete source images by its binary hash.
     *
     * ```js
     * rokka.sourceimages.deleteWithBinaryHash('myorg', 'b23e17047329b417d3902dc1a5a7e158a3ee822a')
     *   .then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @authenticated
     * @param  {string}  organization name
     * @param  {string}  binaryHash   binary image hash
     * @return {Promise}
     */
    deleteWithBinaryHash: function deleteWithBinaryHash(organization, binaryHash) {
      var queryParams = {
        binaryHash: binaryHash
      };
      return state.request('DELETE', "sourceimages/".concat(organization), null, queryParams);
    },

    /**
     * Restore image by hash.
     *
     * ```js
     * rokka.sourceimages.restore('myorg', 'c421f4e8cefe0fd3aab22832f51e85bacda0a47a')
     *   .then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @authenticated
     * @param  {string}  organization name
     * @param  {string}  hash         image hash
     * @return {Promise}
     */
    restore: function restore(organization, hash) {
      return state.request('POST', "sourceimages/".concat(organization, "/").concat(hash, "/restore"));
    },

    /**
     * Copy image by hash to another org.
     *
     * ```js
     * rokka.sourceimages.copy('myorg', 'c421f4e8cefe0fd3aab22832f51e85bacda0a47a', 'anotherorg', true)
     *   .then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @authenticated
     * @param  {string}  organization            the org the image is copied from
     * @param  {string}  hash                    image hash
     * @param  {string}  destinationOrganization the org the image is copied to
     * @param  {boolean} [overwrite=true]     if an existing image should be overwritten
     *
     * @return {Promise}
     */
    copy: function copy(organization, hash, destinationOrganization, overwrite) {
      if (overwrite === void 0) {
        overwrite = true;
      }

      var headers = {
        Destination: destinationOrganization
      };

      if (!overwrite) {
        headers.Overwrite = 'F';
      }

      return state.request('COPY', "sourceimages/".concat(organization, "/").concat(hash), null, null, {
        headers: headers
      });
    },

    /**
     * (Un)sets the protected status of an image.
     *
     * Important! Returns a different hash, if the protected status changes
     *
     * ```js
     * rokka.sourceimages.setProtected('myorg', 'c421f4e8cefe0fd3aab22832f51e85bacda0a47a', true,
     * {
     *   deletePrevious: false
     * }).then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @param {string} organization  name
     * @param {string} hash          image hash
     * @param {boolean} isProtected          If image should be protected or not
          * @param {{deletePrevious: boolean}} [options={}] Optional: only {deletePrevious: true/false} yet, false is default
     * @returns {Promise}
     */
    setProtected: function setProtected(organization, hash, isProtected, options) {
      if (options === void 0) {
        options = {};
      }

      options.deletePrevious = options.deletePrevious ? 'true' : 'false';
      return state.request('PUT', 'sourceimages/' + organization + '/' + hash + '/options/protected', isProtected, options);
    },

    /**
     * (Un)locks an image.
     *
     * Locks an image, which then can't be deleted.
     *
     * ```js
     * rokka.sourceimages.setLocked('myorg', 'c421f4e8cefe0fd3aab22832f51e85bacda0a47a', true).then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @param {string} organization  name
     * @param {string} hash          image hash
     * @param {boolean} isLocked          If image should be protected or not
          * @returns {Promise}
     */
    setLocked: function setLocked(organization, hash, isLocked) {
      return state.request('PUT', 'sourceimages/' + organization + '/' + hash + '/options/locked', isLocked);
    },

    /**
     * ### Dynamic metadata
     *
     * See [the dynamic metadata documentation](https://rokka.io/documentation/references/dynamic-metadata.html) for
     * more information.
     */

    /**
     * Set the subject area of a source image.
     *
     * The [subject area of an image](https://rokka.io/documentation/references/dynamic-metadata.html#subject-area) is
     * used when applying the [crop operation](https://rokka.io/documentation/references/operations.html#crop) with the
     * `auto` anchor to center the cropping box around the subject area.
     *
     * ```js
     * rokka.sourceimages.setSubjectArea('myorg', 'c421f4e8cefe0fd3aab22832f51e85bacda0a47a', {
     *   x: 100,
     *   y: 100,
     *   width: 50,
     *   height: 50
     * },
     * {
     *   deletePrevious: false
     * }).then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @param {string} organization  name
     * @param {string} hash          image hash
     * @param {{width: number, height: number, x: number, y: number}} coords x, y starting from top left
     * @param {{deletePrevious: boolean}} [options={}] Optional: only {deletePrevious: true/false} yet, false is default
     * @returns {Promise}
     */
    setSubjectArea: function setSubjectArea(organization, hash, coords, options) {
      if (options === void 0) {
        options = {};
      }

      options.deletePrevious = options.deletePrevious ? 'true' : 'false';
      return state.request('PUT', 'sourceimages/' + organization + '/' + hash + '/meta/dynamic/subject_area', coords, options);
    },

    /**
     * Removes the subject area from a source image.
     *
     * ```js
     * rokka.sourceimages.removeSubjectArea('myorg', 'c421f4e8cefe0fd3aab22832f51e85bacda0a47a')
     *   .then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @param {string} organization
     * @param {string} hash
     * @param {{deletePrevious: boolean}} [options={}] Optional: only {deletePrevious: true/false} yet, false is default
     * @return {Promise}
     */
    removeSubjectArea: function removeSubjectArea(organization, hash, options) {
      if (options === void 0) {
        options = {};
      }

      options.deletePrevious = options.deletePrevious ? 'true' : 'false';
      return state.request('DELETE', "sourceimages/".concat(organization, "/").concat(hash, "/meta/dynamic/subject_area"), null, options);
    },

    /**
     * Add/set dynamic metadata to an image
     *
     * See [the dynamic metadata chapter](https://rokka.io/documentation/references/dynamic-metadata.html) for
     * details.
     *
     * ```js
     * rokka.sourceimages.addDynamicMetaData('myorg', 'c421f4e8cefe0fd3aab22832f51e85bacda0a47a', 'crop_area', {
     *   x: 100,
     *   y: 100,
     *   width: 50,
     *   height: 50
     * },
     * {
     *   deletePrevious: false
     * }).then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @param {string} organization  name
     * @param {string} hash          image hash
     * @param {string} name          the name of the dynamic metarea
     * @param {any} data            The data to be sent. Usually an object
     * @param {{deletePrevious: boolean}} [options={}] Optional: only {deletePrevious: true/false} yet, false is default
     * @returns {Promise}
     */
    addDynamicMetaData: function addDynamicMetaData(organization, hash, name, data, options) {
      if (options === void 0) {
        options = {};
      }

      options.deletePrevious = options.deletePrevious ? 'true' : 'false';
      return state.request('PUT', 'sourceimages/' + organization + '/' + hash + '/meta/dynamic/' + name, data, options);
    },

    /**
     * Delete dynamic metadata of an image
     *
     * See [the dynamic metadata chapter](https://rokka.io/documentation/references/dynamic-metadata.html) for
     * details.
     *
     * ```js
     * rokka.sourceimages.addDynamicMetaData('myorg', 'c421f4e8cefe0fd3aab22832f51e85bacda0a47a', 'crop_area',
     * {
     *   deletePrevious: false
     * }).then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @param {string} organization  name
     * @param {string} hash          image hash
     * @param {string} name          the name of the dynamic metarea
     * @param {{deletePrevious: boolean}} [options={}] Optional: only {deletePrevious: true/false} yet, false is default
     * @returns {Promise}
     */
    deleteDynamicMetaData: function deleteDynamicMetaData(organization, hash, name, options) {
      if (options === void 0) {
        options = {};
      }

      options.deletePrevious = options.deletePrevious ? 'true' : 'false';
      return state.request('DELETE', 'sourceimages/' + organization + '/' + hash + '/meta/dynamic/' + name, options);
    },

    /**
     * Change the name of a  source image.
     *
     * ```js
     * rokka.sourceimages.putName('myorg', 'c421f4e8cefe0fd3aab22832f51e85bacda0a47a', name).then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @authenticated
     * @param {string} organization name
     * @param {string} hash         image hash
     * @param {string} name         new name of the image
     * @return {Promise}
     */
    putName: function putName(organization, hash, name) {
      return state.request('PUT', "sourceimages/".concat(organization, "/").concat(hash, "/name"), JSON.stringify(name));
    },
    meta: SourceImagesMeta(state)
  };
  return {
    sourceimages: sourceimages
  };
};
/**
 * ### Stack options
 *
 * @module stackoptions
 */


var stackoptions = function stackoptions(state) {
  var stackoptions = {
    /**
     * Returns a json-schema like definition of options which can be set on a stack.
     *
     * ```js
     * rokka.stackoptions.get()
     *   .then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @return {Promise}
     */
    get: function get() {
      return state.request('GET', 'stackoptions', null, null, {
        noAuthHeaders: true
      });
    }
  };
  return {
    stackoptions: stackoptions
  };
};
/**
 * ### Stacks
 *
 * @module stacks
 */


var stacks = function stacks(state) {
  var stacks = {
    /**
     * Get a list of available stacks.
     *
     * ```js
     * rokka.stacks.list('myorg')
     *   .then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @authenticated
     * @param  {string}  organization  name
     * @param  {number}  [limit=null]
     * @param  {string}  [offset=null] cursor
     * @return {Promise}
     */
    list: function list(organization, limit, offset) {
      if (limit === void 0) {
        limit = null;
      }

      if (offset === void 0) {
        offset = null;
      }

      var queryParams = {};

      if (limit !== null) {
        queryParams.limit = limit;
      }

      if (offset !== null) {
        queryParams.offset = offset;
      }

      return state.request('GET', "stacks/".concat(organization), null, queryParams);
    },

    /**
     * Get details about a stack.
     *
     * ```js
     * rokka.stacks.get('myorg', 'mystack')
     *   .then(function(result) {})
     *   .catch(function(result) {});
     * ```
     *
     * @authenticated
     * @param  {string}  organization name
     * @param  {string}  name         stack name
     * @return {Promise}
     */
    get: function get(organization, name) {
      return state.request('GET', "stacks/".concat(organization, "/").concat(name));
    },

    /**
     * Create a new stack.
     *
     * The signature of this method changed in 0.27.
     *
     * Using a single stack operation object (without an enclosing array) as the 3rd parameter (stackConfig) is
     *  since version 0.27.0 not supported anymore.
     *
     * ```js
     * const operations = [
     *   rokka.operations.rotate(45),
     *   rokka.operations.resize(100, 100)
     * ]
     *
     * // stack options are optional
     * const options = {
     *   'jpg.quality': 80,
     *   'webp.quality': 80
     * }
     *
     * // stack expressions are optional
     * const expressions = [
     *   rokka.expressions.default('options.dpr > 2', { 'jpg.quality': 60, 'webp.quality': 60 })
     * ]
     *
     * // query params are optional
     * var queryParams = { overwrite: true }
     * rokka.stacks.create(
     *   'test',
     *   'mystack',
     *   { operations, options, expressions },
     *   queryParams
     * ).then(function(result) {})
     *  .catch(function(err) {})
     * ```
     *
     * @authenticated
     * @param  {string}       organization name
     * @param  {string}       name         stack name
     * @param  {Object}       stackConfig  object with the stack config of stack operations, options and expressions.
     * @param  {{overwrite: bool}} [params={}]  params       query params, only {overwrite: true|false} is currently supported
     * @return {Promise}
     */
    create: function create(organization, name, stackConfig, params) {
      if (params === void 0) {
        params = {};
      }

      var rest = [];

      for (var _i = 4; _i < arguments.length; _i++) {
        rest[_i - 4] = arguments[_i];
      }

      var queryParams = Object.assign({}, params);
      var body = {}; // backwards compatibility for previous signature:
      // create(organization, name, operations, options = null, overwrite = false)

      if (Array.isArray(stackConfig)) {
        body.operations = stackConfig;
        body.options = params;

        var _overwrite = rest.length > 0 ? rest[0] : false;

        queryParams = {};

        if (_overwrite) {
          queryParams.overwrite = _overwrite;
        }
      } else {
        body = stackConfig;
      }

      return state.request('PUT', "stacks/".concat(organization, "/").concat(name), body, queryParams);
    },

    /**
     * Delete a stack.
     *
     * ```js
     * rokka.stacks.delete('myorg', 'mystack')
     *   .then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @authenticated
     * @param  {string}  organization name
     * @param  {string}  name         stack name
     * @return {Promise}
     */
    delete: function _delete(organization, name) {
      return state.request('DELETE', "stacks/".concat(organization, "/").concat(name));
    }
  };
  return {
    stacks: stacks
  };
};
/**
 * ### Stats
 *
 * @module stats
 */


var stats = function stats(state) {
  var stats = {
    /**
     * Retrieve statistics about an organization.
     *
     * If `from` and `to` are not specified, the API will return data for the last 30 days.
     *
     * ```js
     * rokka.stats.get('myorg', '2017-01-01', '2017-01-31')
     *   .then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @param {string} organization name
     * @param {string} [from=null]  date in format YYYY-MM-DD
     * @param {string} [to=null]    date in format YYYY-MM-DD
     *
     * @return {Promise}
     */
    get: function get(organization, from, to) {
      if (from === void 0) {
        from = null;
      }

      if (to === void 0) {
        to = null;
      }

      return state.request('GET', "stats/".concat(organization), null, {
        from: from,
        to: to
      });
    }
  };
  return {
    stats: stats
  };
};

var billing = function billing(state) {
  var billing = {
    /**
     * Retrieve statistics about the billing of an organization
     *
     * If `from` and `to` are not specified, the API will return data for the last 30 days.
     *
     * ```js
     * rokka.billing.get('myorg', '2017-01-01', '2017-01-31')
     *   .then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @param {string} organization name
     * @param {string} [from=null]  date in format YYYY-MM-DD
     * @param {string} [to=null]    date in format YYYY-MM-DD
     *
     * @return {Promise}
     */
    get: function get(organization, from, to) {
      if (from === void 0) {
        from = undefined;
      }

      if (to === void 0) {
        to = undefined;
      }

      return state.request('GET', "billing/".concat(organization), null, {
        from: from,
        to: to
      });
    }
  };
  return {
    billing: billing
  };
};
/**
 * ### Users
 *
 * @module users
 */


var users = function users(state) {
  var users = {
    /**
     * Register a new user for the rokka service.
     *
     * ```js
     * rokka.users.create('user@example.org')
     *   .then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @param {string} email address of a user
     * @param {string} [organization=null] to create
     * @return {Promise}
     */
    create: function create(email, organization) {
      if (organization === void 0) {
        organization = null;
      }

      return state.request('POST', 'users', {
        email: email,
        organization: organization
      }, null, {
        noAuthHeaders: true
      });
    },

    /**
     * Get user_id for current user
     *
     * ```js
     * rokka.users.getId()
     *   .then(function(result) {})
     *   .catch(function(err) {});
     * ```
     *
     * @return {Promise}
     */
    getId: function getId() {
      return state.request('GET', 'user').then(function (result) {
        return result.body.user_id;
      });
    }
  };
  return {
    users: users
  };
};
/**
 * ### User
 *
 * @module user
 */


var user = function user(state) {
  var user = {
    /**
     * Get user_id for current user
     *
     * ```js
     * rokka.users.getId()
     *   .then(function(result) {})
     *   .catch(function(err) {});
     * ```
     * @since 3.3.0
     * @authenticated
     *
     * @return {Promise}
     */
    getId: function getId() {
      return state.request('GET', 'user').then(function (result) {
        return result.body.user_id;
      });
    },

    /**
     * Get user object for current user
     *
     * ```js
     * rokka.user.get()
     *  .then(function(result) {})
     *  .catch(function(err) {});
     * ```
     *
     * @since 3.3.0
     * @authenticated
     *
     * @return {Promise}
     */
    get: function get() {
      return state.request('GET', 'user');
    },

    /**
     * List Api Keys of the current user
          *
     * ```js
     * rokka.user.listApiKeys()
     *  .then(function(result) {})
     *  .catch(function(err) {});
     *  ```
     *
     * @since 3.3.0
     * @authenticated
     *
     * @return {Promise}
     */
    listApiKeys: function listApiKeys() {
      return state.request('GET', 'user/apikeys');
    },

    /**
     * Add Api Key to the current user
     *
     * @param  {string}  comment optional comment
     *
     * ```js
     * rokka.user.addApiKey('some comment')
     *  .then(function(result) {})
     *  .catch(function(err) {});
     * ```
     *
     * @since 3.3.0
     * @authenticated
     *
     * @return {Promise}
     */
    addApiKey: function addApiKey(comment) {
      if (comment === void 0) {
        comment = null;
      }

      return state.request('POST', 'user/apikeys', {
        comment: comment
      });
    },

    /**
     * Delete Api Key from the current user
          *
     * @param  {string}  id the id of the Api Key
     *
     * ```js
     * rokka.user.deleteApiKey(id)
     *  .then(function(result) {})
     *  .catch(function(err) {});
     * ```
     * @since 3.3.0
     * @authenticated
     *
     * @return {Promise}
     */
    deleteApiKey: function deleteApiKey(id) {
      return state.request('DELETE', "user/apikeys/".concat(id));
    },

    /**
     * Get currently used Api Key
     *
     * ```js
     * rokka.user.getCurrentApiKey()
     *  .then(function(result) {})
     *  .catch(function(err) {});
     * ```
     *
     * @since 3.3.0
     * @authenticated
     *
     * @return {Promise}
     */
    getCurrentApiKey: function getCurrentApiKey() {
      return state.request('GET', 'user/apikeys/current');
    },

    /**
     * Gets a new JWT token from the API.
     *
     * You either provide an API Key or there's a valid JWT token registered to get a new JWT token.
     *
     * ```js
     * rokka.user.getNowToken(apiKey, {expires_in: 48 * 3600, renewable: true})
     *  .then(function(result) {})
     *  .catch(function(err) {});
     * ```
     *
     * @since 3.7.0
     * @authenticated
     *
     *
     * @param {string}                      apiKey (optional) If you don't have a valid JWT token, we need an API key to retrieve a new one
     * @param {RequestQueryParamsNewToken}  queryParams (optional) The query parameters used for generating a new JWT token.
     *
     * @return {Promise}
     */
    getNewToken: function getNewToken(apiKey, queryParams) {
      var _this = this;

      if (queryParams === void 0) {
        queryParams = {};
      }

      if (apiKey) {
        state.apiKey = apiKey;
      }

      if (!!queryParams) {
        queryParams = {};
      }

      return state.request('GET', 'user/apikeys/token', undefined, _assign(_assign({}, state.apiTokenOptions), queryParams), {
        forceUseApiKey: !!apiKey && this.getTokenIsValidFor() < 10,
        noTokenRefresh: true
      }).then(function (response) {
        _this.setToken(response.body.token);

        return response;
      });
    },

    /**
     * Gets the currently registered JWT Token from the `apiTokenGetCallback` config function or null
     *
     * @since 3.7.0
     *
     * @return {string|null}
     */
    getToken: function getToken() {
      return state.apiTokenGetCallback ? state.apiTokenGetCallback() : null;
    },

    /**
     * Sets a new JWT token with the `apiTokenSetCallback` function
     *
     * @since 3.7.0
     *
     * @param {string} token
     */
    setToken: function setToken(token) {
      if (state.apiTokenSetCallback) {
        state.apiTokenPayload = _getTokenPayload(token);
        state.apiTokenSetCallback(token, state.apiTokenPayload);
      }
    },

    /**
     * Check if the registered JWT token is expiring within these amount of seconds (default: 3600)
     *
     * @since 3.7.0
     *
     * @param {number} withinNextSeconds Does it expire in these seconds (default: 3600)
     *
     * @return {boolean}
     */
    isTokenExpiring: function isTokenExpiring(withinNextSeconds) {
      var _a;

      if (withinNextSeconds === void 0) {
        withinNextSeconds = 3600;
      }

      return _isTokenExpiring((_a = state.apiTokenPayload) === null || _a === void 0 ? void 0 : _a.exp, state.apiTokenGetCallback, withinNextSeconds);
    },

    /**
     * How long a token is still valid for (just checking for expiration time
     *
     * @since 3.7.0
     *
     * @return {number} The amount of seconds it's still valid for, -1 if it doesn't exist
     */
    getTokenIsValidFor: function getTokenIsValidFor() {
      var _a;

      return _tokenValidFor((_a = state.apiTokenPayload) === null || _a === void 0 ? void 0 : _a.exp, state.apiTokenGetCallback);
    }
  };
  return {
    user: user
  };
};
/**
 * ### request
 *
 * @module request
 */


var request = function request(state) {
  /**
   * Does an authenticated request for any path to the Rokka API
   * @param path    {string}    The path (without leading slash)
   * @param method  {string}    HTTP method, Default GET
   * @param body    {any|null}  The body payload. Default: null
   */
  var request = function request(path, method, body) {
    if (method === void 0) {
      method = 'GET';
    }

    if (body === void 0) {
      body = null;
    }

    return state.request(method, path, body);
  };

  return {
    request: request
  };
};

var modules = function modules(state) {
  return Object.assign({}, memberships(state), operations(state), organizations(state), expressions(), render(state), sourceimages(state), stackoptions(state), stacks(state), stats(state), users(state), billing(state), user(state), request(state));
};

var RokkaResponse = function RokkaResponse(originalResponse) {
  return {
    response: originalResponse,
    body: null,

    get statusCode() {
      return this.response.status;
    },

    get statusMessage() {
      return this.response.statusText;
    }

  };
};

var defaults = {
  apiHost: 'https://api.rokka.io',
  renderHost: 'https://{organization}.rokka.io',
  apiVersion: 1,
  transport: {
    requestTimeout: 30000,
    retries: 10,
    minTimeout: 1000,
    maxTimeout: 10000,
    randomize: true,
    factor: 2,
    debug: false
  }
};

var getResponseBody = function getResponseBody(response, fallbackToText) {
  if (fallbackToText === void 0) {
    fallbackToText = false;
  }

  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      if (response.headers && response.json) {
        if (response.headers.get('content-type') === 'application/json') {
          return [2
          /*return*/
          , response.json()];
        }

        if (response.status === 204 || response.status === 201 || fallbackToText) {
          return [2
          /*return*/
          , response.text()];
        }

        return [2
        /*return*/
        , response.body];
      }

      return [2
      /*return*/
      , response.body];
    });
  });
};
/**
 * Initializing the rokka client.
 *
 * ```js
 * const rokka = require('rokka')({
 *   apiKey: 'apikey',                  // required for certain operations
 *   apiTokenGetCallback?: <() => string> // return JWT token instead of API Key
 *   apiTokenSetCallback?: <((token: string, payload?: object|null) => void)> // Stores a newly retrieved JWT token
 *   apiTokenOptions?: <object>         // The rokka.user.getNewToken query parameter options, default: {}
 *   apiTokenRefreshTime?: <number>     // how many seconds before the token is expiring, it should be refreshed, default: 3600
 *   apiHost: '<url>',                  // default: https://api.rokka.io
 *   apiVersion: <number>,              // default: 1
 *   renderHost: '<url>',               // default: https://{organization}.rokka.io
 *   debug: true,                       // default: false
 *   transport: {
 *     requestTimeout: <number>,  // milliseconds to wait for rokka server response (default: 30000)
 *     retries: <number>,         // number of retries when API response is 429 (default: 10)
 *     minTimeout: <number>,      // minimum milliseconds between retries (default: 1000)
 *     maxTimeout: <number>,      // maximum milliseconds between retries (default: 10000)
 *     randomize: <boolean>       // randomize time between retries (default: true)
 *     agent?: <any>               // an agent to be used with node-fetch, eg. if you need a proxy (default: undefined)
 *   }
 * });
 * ```
 *
 * All properties are optional since certain calls don't require credentials.
 *
 * If you need to use a proxy, you can do the following
 *
 * ```js
 * import { HttpsProxyAgent } from 'https-proxy-agent'
 *
 * const rokka = require('rokka')({
 *  apiKey: 'apikey'
 *  transport: {agent: new HttpsProxyAgent(proxy)}
 * });
 * ```
 *
 * @param  {Object} [config={}] configuration properties
 * @return {Object}
 *
 * @module rokka
 */


var index = function index(config) {
  if (config === void 0) {
    config = {};
  }

  var state = {
    // config
    apiKey: config.apiKey,
    apiHost: config.apiHost || defaults.apiHost,
    apiTokenGetCallback: config.apiTokenGetCallback || null,
    apiTokenSetCallback: config.apiTokenSetCallback || null,
    apiTokenPayload: null,
    apiTokenOptions: config.apiTokenOptions || {},
    apiTokenRefreshTime: config.apiTokenRefreshTime || 3600,
    apiVersion: config.apiVersion || defaults.apiVersion,
    renderHost: config.renderHost || defaults.renderHost,
    transportOptions: Object.assign(defaults.transport, config.transport),
    // functions
    request: function request(method, path, payload, queryParams, options) {
      var _a, _b, _c;

      if (payload === void 0) {
        payload = null;
      }

      if (queryParams === void 0) {
        queryParams = null;
      }

      if (options === void 0) {
        options = {
          noAuthHeaders: false,
          fallBackToText: false,
          forceUseApiKey: false,
          noTokenRefresh: false,
          host: undefined
        };
      }

      return __awaiter(this, void 0, void 0, function () {
        var uri, headers, apiToken, isTokenValid, isTokenExpiring, e_1, code, retryDelay, requestOptions, formData_1, requestData_1, formData_2, requestData_2, t;

        var _this = this;

        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              uri = [options.host || state.apiHost, path].join('/');

              if (queryParams && !(Object.entries(queryParams).length === 0 && queryParams.constructor === Object)) {
                uri += '?' + stringify(queryParams);
              }

              headers = options.headers || {};
              headers['Api-Version'] = state.apiVersion;
              if (!(options.noAuthHeaders !== true)) return [3
              /*break*/
              , 6];
              if (!(!options.forceUseApiKey && state.apiTokenGetCallback)) return [3
              /*break*/
              , 5];
              apiToken = state.apiTokenGetCallback(); // fill apiTokenPayload, if not set, this happens when you load a page, for example

              if (!state.apiTokenPayload) {
                state.apiTokenPayload = _getTokenPayload(apiToken);
              }

              isTokenValid = apiToken && ((_a = state.apiTokenPayload) === null || _a === void 0 ? void 0 : _a.rn) === true && _tokenValidFor((_b = state.apiTokenPayload) === null || _b === void 0 ? void 0 : _b.exp, apiToken) > 0;
              isTokenExpiring = isTokenValid && _isTokenExpiring((_c = state.apiTokenPayload) === null || _c === void 0 ? void 0 : _c.exp, apiToken, state.apiTokenRefreshTime);
              if (!(!options.noTokenRefresh && isTokenValid && isTokenExpiring || !isTokenValid && state.apiKey) //or do we have an apiKey
              ) return [3
              /*break*/
              , 4]; //or do we have an apiKey

              _d.label = 1;

            case 1:
              _d.trys.push([1, 3,, 4]);

              return [4
              /*yield*/
              , user(state).user.getNewToken(state.apiKey)];

            case 2:
              apiToken = _d.sent().body.token;
              return [3
              /*break*/
              , 4];

            case 3:
              e_1 = _d.sent(); // clear the api token so that we can enforce a new login usually
              //  a 403 means that we couldn't get a new token (trying to get a longer expiry time for example)

              if (e_1 && e_1.statusCode === 403 && state.apiTokenSetCallback) {
                state.apiTokenSetCallback('', null);
              }

              return [3
              /*break*/
              , 4];

            case 4:
              if (!apiToken) {
                code = 401;
                throw {
                  error: {
                    code: code,
                    message: 'No API token (or renewing it did not work correctly)'
                  },
                  status: code
                };
              } // set apiTokenExpiry, if not set, to avoid to having to decode it all the time


              headers['Authorization'] = "Bearer ".concat(apiToken);
              return [3
              /*break*/
              , 6];

            case 5:
              if (!state.apiKey) {
                return [2
                /*return*/
                , Promise.reject(new Error('Missing required property `apiKey`'))];
              }

              headers['Api-Key'] = state.apiKey;
              _d.label = 6;

            case 6:
              retryDelay = function retryDelay(attempt) {
                // from https://github.com/tim-kos/node-retry/blob/master/lib/retry.js
                var random = state.transportOptions.randomize ? Math.random() + 1 : 1;
                var timeout = Math.round(random * state.transportOptions.minTimeout * Math.pow(state.transportOptions.factor, attempt));
                return Math.min(timeout, state.transportOptions.maxTimeout);
              };

              requestOptions = {
                method: method,
                headers: headers,
                timeout: state.transportOptions.requestTimeout,
                retries: state.transportOptions.retries,
                retryDelay: retryDelay,
                form: {},
                json: false,
                body: undefined,
                agent: state.transportOptions.agent
              };

              if (options.form === true) {
                formData_1 = payload || {};
                requestData_1 = new FormData();
                Object.keys(formData_1).forEach(function (meta) {
                  requestData_1.append(meta, formData_1[meta]);
                });
                requestOptions.body = requestData_1;
              } else if (options.multipart !== true) {
                requestOptions.json = true;
                requestOptions.body = payload;
              } else {
                formData_2 = payload.formData || {};
                requestData_2 = new FormData();
                requestData_2.append(payload.name, payload.contents, payload.filename);
                Object.keys(formData_2).forEach(function (meta) {
                  requestData_2.append(meta, JSON.stringify(formData_2[meta]));
                });
                requestOptions.body = requestData_2;
              }

              if (requestOptions.json && requestOptions.body && typeof requestOptions.body === 'object') {
                requestOptions.body = JSON.stringify(requestOptions.body);
              }

              t = transport(uri, requestOptions);
              return [2
              /*return*/
              , t.then(function (response) {
                return __awaiter(_this, void 0, void 0, function () {
                  var rokkaResponse, _a;

                  return __generator(this, function (_b) {
                    switch (_b.label) {
                      case 0:
                        rokkaResponse = RokkaResponse(response);
                        _a = rokkaResponse;
                        return [4
                        /*yield*/
                        , getResponseBody(response, options.fallBackToText)];

                      case 1:
                        _a.body = _b.sent();

                        if (response.status >= 400) {
                          rokkaResponse.error = rokkaResponse.body;
                          rokkaResponse.message = response.status + ' - ' + JSON.stringify(rokkaResponse.body); // if response is a 401 and we have apiTokenSetCallback, clear the token

                          if (response.status === 401 && state.apiTokenSetCallback && state.apiTokenGetCallback) {
                            // but not when the authorization header changed in the meantime
                            if (headers['Authorization'] === 'Bearer ' + state.apiTokenGetCallback()) {
                              state.apiTokenSetCallback('', null);
                              state.apiTokenPayload = null;
                            }
                          }

                          throw rokkaResponse;
                        }

                        return [2
                        /*return*/
                        , rokkaResponse];
                    }
                  });
                });
              })];
          }
        });
      });
    }
  };
  return Object.assign({}, modules(state));
};

export { index as default };